import { graphql, StaticQuery } from 'gatsby';
import * as React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import LayoutFrame from '../components/layout/LayoutFrame';
import usePlatform from '../components/hooks/usePlatform';

interface IDefaultLayoutProps {
  title: string;
  path: string;
}
interface IStaticQueryProps {
  site: {
    siteMetadata: {
      title: string;
      description: string;
    };
  };
}

const PrimaryLayout: React.FunctionComponent<IDefaultLayoutProps> = ({ children, title, path }) => (
  <StaticQuery
    query={graphql`
      query PrimaryLayoutQuery {
        site {
          siteMetadata {
            title
            description
          }
        }
      }
    `}
    render={(data: IStaticQueryProps) => {
      const platform = usePlatform(path);
      let pagePlatform = '';
      if (platform && !title.match(/(Angular|React|Web)/)) {
        const platformTitle = platform.charAt(0).toUpperCase() + platform.slice(1);
        pagePlatform = ` ${platformTitle}`;
      }
      return (
        <>
          <HelmetProvider>
            <Helmet
              title={`${title} | ${data.site.siteMetadata.title}${pagePlatform}`}
              meta={[
                {
                  name: 'description',
                  content: data.site.siteMetadata.description,
                },
              ]}
              link={[
                {
                  rel: 'shortcut icon',
                  type: 'image/png',
                  href: require('../assets/images/favicon.png'),
                },
              ]}
            />
          </HelmetProvider>
          <LayoutFrame title={title} path={path}>
            {children}
          </LayoutFrame>
        </>
      );
    }}
  />
);

export default PrimaryLayout;
